import { Injectable } from '@angular/core';

import { LoaderFactory } from '@shared/factories/loader/loader.factory';

@Injectable({
    providedIn: 'root'
})

export class  OpenLoaderResolver  {
    constructor(private loader: LoaderFactory) { }
    resolve() {
        this.loader.openLoader('concept-precharged-info')
    }
}
